import type { GetFeaturesInnerParams } from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';
import { getDepositAmountLabel } from '@/app/components/search/components/Card/utils/featureUtils.ts';
import { isSplitPaymentsEligible } from '@/app/components/search/components/DeferredPayments/splitPayments.ts';

export const getDepositFeature = ({
  hasDepositAmount,
  dealCard,
  localization,
  isDP,
  isHO,
  searchParams,
  t,
}: GetFeaturesInnerParams): Feature[] => {
  const totalPrice = dealCard?.product?.rate?.price?.total?.price;

  if (isSplitPaymentsEligible({ localization, totalPrice, isHO })) {
    return [{ text: t('vacation.oss.cards.usp.split_payments'), featureType: FeatureType.bold }];
  }

  if (hasDepositAmount && dealCard) {
    const depositAmountLabel = getDepositAmountLabel({ dealCard, localization, isDP, searchParams, t });
    return [{ text: depositAmountLabel, featureType: isDP ? FeatureType.normal : FeatureType.bold }];
  }

  return [];
};
